export default {plugin:{serarch_info:{ui:{search_by:'搜索提供'}}}};